export default "__VITE_ASSET__CPBK5etP__"